"use client"

import { Weight } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WeightIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WeightIcon = component(Icon)({ as: Weight })
